import { createAtom, useSelector } from '@tanstack/react-store';

export const BuildType = {
  default: 'default',
  embedded: 'embedded',
} as const;

export type BuildType = (typeof BuildType)[keyof typeof BuildType];

const getDefaultBuildType = (): BuildType => {
  const rawBuildType: unknown = import.meta.env.VITE_APP_BUILD_TYPE;
  const variant = typeof rawBuildType === 'string' ? rawBuildType : undefined;

  if (variant === undefined || variant === '') {
    return BuildType.default;
  }

  if (variant === BuildType.default || variant === BuildType.embedded) {
    return variant;
  }

  throw new Error(`Unknown variant ${variant}`);
};

export const buildTypeAtom = createAtom(getDefaultBuildType());

export function setBuildType(buildType: BuildType) {
  buildTypeAtom.set(buildType);
}

export function useBuildType() {
  return useSelector(buildTypeAtom, (state) => state);
}

export function useIsEmbedded(): boolean {
  return useBuildType() === BuildType.embedded;
}

export function useIsStandalone(): boolean {
  return useBuildType() === BuildType.default;
}
